import type { StepsProps } from 'antd';
import { Popover, Steps,Card } from 'antd';
import React,{ useState, useEffect } from 'react';

interface props {
  enums?: any
  enumsName?: any
  current?:any
}

const customDot: StepsProps['progressDot'] = (dot, { status, index }) => (
  <Popover
  >
    {dot}
  </Popover>
);

const SPSteps: React.FC<props> = (props) => {
  const { enums, enumsName, current } = props
  const [items , setItems] = useState([])

  const getItems = () => {
    let arr:any = []
    enums[enumsName]?.map((item: any, index: any) => {
      arr.push({ title: item.value })
    })
    return arr
  }

  useEffect(() => {
    setItems(getItems())
  }, [])

  return (<Card style={{ marginBottom: 10 }}>
    <Steps
      current={current}
      progressDot={customDot}
      items={items}
    />
  </Card>)
};

export default SPSteps;
